<template>
  <div class="tree-sidebar"
    role="tree"
    :aria-label="ariaLabel"
    aria-describedby="tree-sidebar-navigation-hint"
    @keydown="handleKeydown"
    @focusin="handleFocusIn"
  >
    <p id="tree-sidebar-navigation-hint" class="sr-only">
      Use the arrow keys to move between files and folders. Press Enter or Space to open a file or expand and collapse a folder.
    </p>
    <tree-node
      :node="tree"
      :current-filename="`./${currentFilename}`"
      :changed-files="sanitisedChangedFiles"
      :show-cwd="false"
      :edit-mode="editMode"
      @fileclicked="fileClicked"
    ></tree-node>
  </div>
</template>

<style>
.tree-sidebar > .tree-node {
  position: relative;
  display: block;
  margin-top: 1em;
  font-size: 0.85em;
}

.tree-node > ul.folders-container,
.tree-sidebar > ul {
  padding-left: 0;
}

.tree-sidebar > .tree-node::-webkit-scrollbar-thumb,
.tree-sidebar::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-thumb);
  border-radius: 3px;
  box-shadow: none;
}

</style>

<style scoped>
.tree-sidebar {
  width: 100%;
  height: 100%;
  overflow: auto;
  white-space: nowrap;
}

.tree-sidebar::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}

</style>

<script>
import {
  getVisibleTreeItems,
  handleTreeKeydown,
  initTreeTabIndex,
  setRovingTabIndex,
} from '@utils/tree-sidebar-keyboard';
import TreeNode from './tree-sidebar-node.vue';

export default {
  components: {
    'tree-node': TreeNode,
  },
  props: {
    changedFiles: {
      type: Array,
      default: () => [],
    },
    tree: {
      type: Object,
      required: true,
    },
    currentFilename: {
      type: String,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    ariaLabel: {
      type: String,
      default: 'File tree',
    },
  },
  data() {
    return {
      tabIndexReady: false,
    };
  },
  computed: {
    sanitisedChangedFiles() {
      return this.changedFiles.map(x => `./${x}`);
    },
  },
  watch: {
    tree: {
      handler() {
        this.initTabIndexOnce();
      },
      deep: true,
    },
  },
  mounted() {
    this.initTabIndexOnce();
  },
  methods: {
    initTabIndexOnce() {
      if (this.tabIndexReady) {
        return;
      }
      this.$nextTick(() => {
        this.tabIndexReady = initTreeTabIndex(this.$el);
      });
    },
    handleKeydown(event) {
      handleTreeKeydown(this.$el, event);
    },
    handleFocusIn(event) {
      const item = event.target.closest('[role="treeitem"]');
      if (item && this.$el.contains(item)) {
        setRovingTabIndex(getVisibleTreeItems(this.$el), item);
      }
    },
    fileClicked(payload) {
      this.$emit('fileclicked', payload.slice(2));
    },
  },
};
</script>
